export default function timeAgo(dateString) {
  const date = new Date(dateString);
  const now = new Date();
  const diff = now - date;

  const seconds = Math.floor(diff / 1000);
  if (seconds < 60) {
    return seconds == 1 ? `${seconds} second ago` : `${seconds} seconds ago`;
  }

  const minutes = Math.floor(diff / (1000 * 60));
  if (minutes < 60) {
    return minutes == 1 ? `${minutes} minute ago` : `${minutes} minutes ago`;
  }

  const hours = Math.floor(diff / (1000 * 60 * 60));
  if (hours < 24) {
    return hours == 1 ? `about ${hours} hour ago` : `about ${hours} hours ago`;
  }

  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  if (days < 365) {
    return days == 1 ? `about ${days} day ago` : `about ${days} days ago`;
  }

  const years = Math.floor(diff / (1000 * 60 * 60 * 24 * 365));
  return years == 1 ? `about ${years} year ago` : `about ${years} years ago`;
}
